import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-47dad35c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = { class: "textDashboard" }
const _hoisted_3 = { class: "container-img" }
const _hoisted_4 = { class: "title-card" }
const _hoisted_5 = { class: "textDashboard" }
const _hoisted_6 = { class: "subtitle-card" }
const _hoisted_7 = { class: "ip-card" }

import { computed } from 'vue';

/********************************
 ********** CONSTANTES **********
 *******************************/
import { COLOR } from '@/constants/colors';
import CONSTANTIMGS from '@/constants/images';

/********************************
 ********** INTERFACES **********
 *******************************/
import { IMGS } from '@/interfaces/SmartLink/Imgs';


export default /*#__PURE__*/_defineComponent({
  __name: 'CardTopology',
  props: {
    status      :{ type:String, required:true, },
    title       :{ type:String, required:true, },
    ip          :{ type:String, required:true, },
    description :{ type:String, required:true, },
},
  setup(__props) {

const props = __props;



const colorBG             = computed(() => COLOR.bgpredict);

const CONST_IMG:IMGS        = {
    "PMP-SM"        : CONSTANTIMGS.IMAGES.onlypmp,
    "PMP"           : CONSTANTIMGS.IMAGES.onlypmp,
    "PMP-AP"        : CONSTANTIMGS.IMAGES.onlypmp,
};

const images                = computed(() => CONST_IMG[props.description])



return (_ctx: any,_cache: any) => {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_sheet = _resolveComponent("v-sheet")!

  return (_openBlock(), _createBlock(_component_v_sheet, {
    style: _normalizeStyle('background-color:'+colorBG.value+'!important'),
    color: "bgCard",
    class: "cardTopology"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, {
        class: "ma-0 pa-0",
        cols: "12",
        "align-self": "center"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_v_chip, {
              class: _normalizeClass(["ma-2", 'normalChip']),
              color: _unref(COLOR).greyfake
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_2, _toDisplayString(__props.status.toUpperCase()), 1)
              ]),
              _: 1
            }, 8, ["color"]),
            _createElementVNode("div", _hoisted_3, [
              (images.value !== null)
                ? (_openBlock(), _createBlock(_component_v_img, {
                    key: 0,
                    class: "img-topo",
                    src: images.value
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(__props.title), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(__props.description), 1)
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(__props.ip), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["style"]))
}
}

})